import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../api/axiosConfig";

function TestResult() {
  const { courseId, kind, testId } = useParams();
  const [review, setReview] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    api
      .get(`/learn/${courseId}/tests/${kind}/${testId}/result`)
      .then((res) => {
        if (!cancelled) setReview(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.message || "Result not available.");
      });
    return () => {
      cancelled = true;
    };
  }, [courseId, kind, testId]);

  if (!review && !error) return <p className="text-center py-5">Loading result...</p>;
  if (!review?.score) {
    return (
      <main className="section-space">
        <div className="container">
          <p>{error}</p>
          <Link to={`/my-courses/${courseId}`}>Back to course</Link>
        </div>
      </main>
    );
  }

  const { test, score } = review;
  const percent =
    score.maxMarks > 0
      ? Math.max(0, Math.min(100, Math.round((score.marks / score.maxMarks) * 100)))
      : 0;
  const base = `/my-courses/${courseId}/tests/${kind}/${testId}`;

  return (
    <main className="exam-page section-space">
      <div className="container exam-result">
        <p className="my-course-back">
          <Link to={`/my-courses/${courseId}`}>← Back to course</Link>
        </p>
        <p className="learn-kicker">Result</p>
        <h1>{test.title}</h1>
        <div className="score-ring" style={{ "--score": `${percent}%` }}>
          <div>
            <strong>{score.marks}</strong>
            <span>of {score.maxMarks}</span>
          </div>
        </div>
        <div className="score-stats">
          <article>
            <span>Correct</span>
            <strong>{score.correct}</strong>
          </article>
          <article>
            <span>Wrong</span>
            <strong>{score.wrong}</strong>
          </article>
          <article>
            <span>Skipped</span>
            <strong>{score.skipped}</strong>
          </article>
          <article>
            <span>Positive</span>
            <strong>{score.positive}</strong>
          </article>
          <article>
            <span>Negative</span>
            <strong>{score.negative}</strong>
          </article>
        </div>
        <div className="test-actions">
          <Link className="btn-view-course" to={`${base}/analysis`}>
            View analysis
          </Link>
          <Link className="test-action-secondary" to={base}>
            Re-attempt
          </Link>
        </div>
      </div>
    </main>
  );
}

export default TestResult;
